export default __webpack_public_path__ + "waves-roi-calculator.svg";